import React, { useEffect } from 'react';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { useUser } from '@src/state/user/hooks';

export const EmailAddress = () => {
  const form = useForm();

  const userInfo = useUser.state();

  useEffect(() => {
    form.setValue('attestation.emailAddress', userInfo?.email);
  }, []);

  return (
    <React.Fragment>
      <TextInput
        id="email-address"
        model="attestation.emailAddress"
        label="Email address"
        helper='If you would like to change your email, please navigate to the "My
        Account" tab in the top right and edit your account settings.'
        type="email"
        isDisabled
        data-testid="attestation-email-address"
      />
    </React.Fragment>
  );
};

EmailAddress.propTypes = {};

EmailAddress.defaultProps = {};
